<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t('general.authorization') }}</li>
            <li>{{ $t('general.permissions') }}</li>

          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t('general.permissions') }}</span>
          </h2>
        </div>
        <!-- <div class="section-header-right">
          <router-link :to="{ name: 'company.authorization.add-edit-permission' }">
            <button class="btn btn-default" type="button" aria-expanded="false">
              <i class="uil-plus"></i> Yeni İzin Ekle
            </button>
          </router-link>
        </div> -->
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                  :placeholder="$t('general.search')" />
              </div>
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a href="#" class="btn btn-icon btn-hover  btn-circle" :uk-tooltip="$t('filters.sort_list')" title=""
                aria-expanded="false">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up" class="uk-dropdown">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('name', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('name', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_asc") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_desc") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t('general.permission_name') }}</th>
                <th scope="col">{{ $t('general.created_at') }}</th>
                <th scope="col">{{ $t('general.updated_date') }}</th>
                <!-- <th scope="col" style="text-align: right;">İşlemler</th> -->
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="(item, index) in flattenedPermissions" :key="index" class="permission-group">
                <th scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child">
                        <i class="uil uil-user-circle"></i>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                      {{ item.name }}
                    </div>
                  </div>
                </th>
                <td>
                  <div class="role-type">
                    <i class="uil-lock" />
                    <!-- <i class="uil-lock-open-alt" /> -->
                    {{ timeFromDate(item.created_at) }}
                  </div>
                </td>
                <td>{{ timeFromDate(item.updated_at) }}</td>
                <!-- <td class="text-right">
                  <div class="actions ml-3">
                    <router-link :to="{
                      name: 'company.authorization.add-edit-permission',
                      params: { id: item.id, name: item.name, },
                    }" class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('faq_categories.edit')">
                      <i class="uil-pen"></i>
                    </router-link>
                    <a href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle" uk-tooltip="Sil"
                      title="" aria-expanded="false">
                      <i class="uil-trash"></i>
                    </a>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
          @changePage="setPage($event)"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DataTable from "@/assets/components/dataTable/DataTable";
import store from "@/core/services";
import Pagination from "@/assets/components/Pagination";
import gift_module, {
  BASE_URL as GIFT_BASE_URL,
  MODULE_NAME as GIFT_MODULE_NAME,
  ERROR as GIFT_ERROR,
  ITEMS as GIFT_ITEMS,
  GET_ITEMS as GIFT_GET_ITEMS,
  DELETE_ITEM as GIFT_DELETE_ITEM,
} from "@/core/services/store/gift.module";
import axios from "axios";
import moment from "moment";
export default {
  name: "PermissionList",
  components: { DataTable, Pagination },
  data() {
    return {
      permissions: {},
      status_id: null,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      sort_by: "id",
      sort_desc: "desc",
      filter: {
        search: null,
        orderBy: "id",
        sort: "desc",
      },
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(GIFT_MODULE_NAME, gift_module);
  },
  computed: {
    flattenedPermissions() {
      // Object.values ile tüm gruplardaki item'ları birleştiriyoruz
      return Object.values(this.permissions).flat();
    },
    items: {
      get() {
        return store.getters[GIFT_MODULE_NAME + "/" + GIFT_ITEMS];
      },
      set(value) { },
    },
    error: {
      get() {
        return store.getters[GIFT_MODULE_NAME + "/" + GIFT_ERROR];
      },
      set(value) { },
    },
  },
  methods: {
    timeFromDate(value) {
      const today = new Date()
      var inputDate = new Date(value);
      return inputDate ? moment(inputDate).locale(this.secureLocalStorage("language")).format('DD MMMM YYYY') : ''

    },
    getPermissions() {
      let self = this;
      axios.get(`${'api/permissions'}`, {
        headers: this.apiHeaders
      }).then((result) => {
        this.permissions = result.data;
      });
    },
    removeGift(id) {
      this.$store
        .dispatch(GIFT_MODULE_NAME + "/" + GIFT_DELETE_ITEM, {
          url: GIFT_BASE_URL + "/" + id,
        })
        .then(() => {
          if (!this.error) {
            this.successMessage = this.$t("general.successfully_deleted");
            this.getGiftResult();
          } else this.errorMessages.push(this.error);
        });
    },
    sortOrder(orderBy, sort, is_user = true) {
      let self = this;
      self.page = 1;
      self.filter.orderBy = orderBy;
      self.filter.sort = sort;

      this.getGiftResult();
    },
    setPage(page, is_user = true) {
      let self = this;
      self.page = page;
      this.getGiftResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getPermissions();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
</style>
